// Views
import ErrorFallback from '../views/ErrorFallback';
import TokenApi from '../views/TokenApi';
import Detail from '../views/Detail';

// Components
import Timeline from '../views/Timeline';
import Logout from '../views/Logout';
import Page from '../components/templates/Page/Page';

/**
 *  @type {Route[]}
 */
const publicRoutes = [
  {
    path: '/token',
    element: <TokenApi />,
    errorElement: <ErrorFallback />,
  },
  {
    path: '/logout',
    element: <Logout />,
    errorElement: <ErrorFallback />,
  },
  {
    path: '/timeline',
    element: (
      <Page page={{
        template: 'timeline', path: '/timeline', contexte: '', format: null,
      }}
      >
        <Timeline page={{
          template: 'timeline', path: '/timeline', contexte: '', format: null,
        }}
        />
      </Page>
    ),
    errorElement: <ErrorFallback />,
  },
  {
    path: '/detail',
    element: (
      <Page page={{
        template: 'detail', path: '/detail', contexte: '', format: null,
      }}
      >
        <Detail page={{
          template: 'detail', path: '/detail', contexte: '', format: null,
        }}
        />
      </Page>
    ),
    errorElement: <ErrorFallback />,
  },
];

export default [
  ...publicRoutes,
];
